import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SingleGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String'];
}>;


export type SingleGroupQuery = { __typename?: 'QueryModel', projectRequests?: { __typename?: 'ProjectRequestQueryModel', singleGroup?: { __typename?: 'ProjectRequestGroup', groupId: string, type: Types.GroupType, requests?: Array<{ __typename?: 'ProjectRequest', state: Types.ProjectRequestState, officeCode: string, scope: string, invoiceContact?: string | null, taxableServices: boolean, projectInstructions?: string | null, name: string, createdOn: any, fieldMeetInfo?: string | null, survey?: string | null, requestId: string, section?: string | null, clientContactName: string, block?: string | null, budget?: number | null, officeInstructions?: string | null, township?: string | null, governmentFunding: Types.GovernmentFundingType, rejectedReason?: string | null, afe?: string | null, range?: string | null, jobsFolderRequired: boolean, jobsFolderDriveLetter?: string | null, coGo?: string | null, fieldInstructions?: string | null, city: string, createdDate: string, statusMessage?: string | null, additionalComments?: string | null, fieldContact?: string | null, invoiceSubmitEmail?: string | null, lastCheckoutTime?: any | null, simplifiedName: string, projectOrigination?: Types.ProjectOrigination | null, projectOriginationName?: string | null, checkedOutBy?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, customer?: { __typename?: 'Customer', customerId: number, name: string, number?: string | null, status: Types.CustomerStatus, address1: string, address2: string, phone: string, fax: string, zip: string, createCustomerRequestId: string, city: string, country: string, state: string, attn?: string | null, adminNotes?: string | null } | null, approver?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, groupedFolder?: { __typename?: 'GroupedFolder', id: number, name: string, syncStatus: Types.SyncStatus } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, projectManager?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', legacyWorkCode: string, displayName: string, isOverhead: boolean, projectType: string, description: string, industry: string } | null, requester?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null } | null> | null } | null } | null };


export const SingleGroupDocument = gql`
    query SingleGroup($groupId: String!) {
  projectRequests {
    singleGroup(groupId: $groupId) {
      groupId
      type
      requests {
        state
        officeCode
        scope
        invoiceContact
        taxableServices
        projectInstructions
        checkedOutBy {
          userPrincipalName
          firstName
          middleInitial
          lastName
        }
        customer {
          customerId
          name
          number
          status
          name
          address1
          address2
          phone
          fax
          zip
          createCustomerRequestId
          city
          country
          state
          status
          attn
          adminNotes
        }
        approver {
          userPrincipalName
          firstName
          middleInitial
          lastName
        }
        name
        createdOn
        fieldMeetInfo
        survey
        requestId
        section
        clientContactName
        block
        budget
        officeInstructions
        township
        governmentFunding
        rejectedReason
        afe
        eogAfeType {
          gen
          sub
          description
          afeType
        }
        range
        jobsFolderRequired
        jobsFolderDriveLetter
        groupedFolder {
          id
          name
          syncStatus
        }
        coGo
        fieldInstructions
        location {
          state
          county
        }
        city
        createdDate
        projectManager {
          userPrincipalName
          firstName
          middleInitial
          lastName
        }
        statusMessage
        additionalComments
        serviceDescription {
          legacyWorkCode
          displayName
          isOverhead
          projectType
          description
          industry
        }
        fieldContact
        requester {
          userPrincipalName
          firstName
          middleInitial
          lastName
        }
        invoiceSubmitEmail
        lastCheckoutTime
        simplifiedName
        projectOrigination
        projectOriginationName
      }
    }
  }
}
    `;

/**
 * __useSingleGroupQuery__
 *
 * To run a query within a React component, call `useSingleGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSingleGroupQuery(baseOptions: Apollo.QueryHookOptions<SingleGroupQuery, SingleGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleGroupQuery, SingleGroupQueryVariables>(SingleGroupDocument, options);
      }
export function useSingleGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleGroupQuery, SingleGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleGroupQuery, SingleGroupQueryVariables>(SingleGroupDocument, options);
        }
export type SingleGroupQueryHookResult = ReturnType<typeof useSingleGroupQuery>;
export type SingleGroupLazyQueryHookResult = ReturnType<typeof useSingleGroupLazyQuery>;
export type SingleGroupQueryResult = Apollo.QueryResult<SingleGroupQuery, SingleGroupQueryVariables>;